const calculatePercentage = (total: number, subTotal: number) =>
   (subTotal / total) * 100

export { calculatePercentage }
